import { Locale } from '../../../../i18n';

export default function generateAuthenticatorResetEmailBody(
  email: string,
  language: Locale,
): string {
  return language === Locale.en
    ? `Dear PACIFIC Team,

I am reaching out for assistance with my PACIFIC account. I have lost access to my authenticator app and am unable to complete Two Factor Authentication during login. Please reset my authenticator so I can enroll a new one on my next login.

My account: ${email}

Email of verifying colleague (another PACIFIC user from my company with admin role who can confirm this request): [ENTER_ADMIN_EMAIL_HERE]

Please assist me in resolving this issue. Thank you for your support.

Best regards,`
    : `Sehr geehrtes PACIFIC-Team,

ich benötige Unterstützung bezüglich meines PACIFIC-Kontos. Ich habe keinen Zugang mehr zu meiner Authentifikator-App und bin nicht in der Lage, die Zwei-Faktor-Authentifizierung beim Anmelden abzuschließen. Bitte setzen Sie meinen Authentifikator zurück, damit ich beim nächsten Login einen neuen einrichten kann.

Mein Konto: ${email}

E-Mail eines bestätigenden Kollegen (ein anderer PACIFIC-Nutzer aus meinem Unternehmen mit Admin-Rolle, der diese Anfrage bestätigen kann): [ADMIN_EMAIL_HIER_EINGEBEN]

Bitte helfen Sie mir, dieses Problem zu lösen. Vielen Dank für Ihre Unterstützung.

Mit freundlichen Grüßen,`;
}
